module.exports = __webpack_public_path__ + "static/media/logo.924a4840.svg";